import React from 'react';
import './VersionTag.css';

function VersionTag({version, color, throwErrorOnClick}) {
    const handleClick = () => {
        if (throwErrorOnClick) throw new Error('ERROR_TEST');
    };

    const containerStyle = () => {
        return {
            color: color || '#111111'
        };
    };

    return (
        <div className='version-tag' onClick={handleClick} style={containerStyle()}>{version ? `v${version}` : 'Unknown'}</div>
    );
}

export default VersionTag;